module.exports = __webpack_public_path__ + "static/img/4.9af7b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hlw/4.png
// module id = DMxJ
// module chunks = 1